import React from "react";
import { getCustomErrorMessage } from "./CustomErrors";
import { Box } from "@mui/material";
import styles from "./ErrorHandlingComponent.module.scss";
import i18n from "i18next";

const Errorhandlingcomponent = (props) => {
  const { error } = props;
  const errorMessage = getCustomErrorMessage(error);
  const navigateToHome = () => {
    window.location.assign("/");
  };
  const tryAgain = () => {
    window.location.reload();
  };

  return (
    <>
      <Box role="alert" className={styles.ErrorBoundaryWrapper} data-testid="error-handling-component-test">
        <pre>{errorMessage}</pre>
        <Box className={styles.buttonWrapper}>
          <button className="muibtn muibtn-primary" data-testid="try-again" onClick={() => tryAgain()}>
            {i18n.t("Try Again")}
          </button>
          <button
            data-testid="navigate"
            className="muibtn muibtn-primary"
            onClick={() => navigateToHome()}
          >
            {i18n.t("Go to Home")}
          </button>
        </Box>
      </Box>
    </>
  );
};

export default Errorhandlingcomponent;
